import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  public activedTool$ = new BehaviorSubject('risk-matrix');

  constructor() {
    this.activedTool$.subscribe();
  }

  public setActivedTool(value): void {
    this.activedTool$.next(value);
  }
}
